$(function () {
  PrintAuthor(author);
  Printbook(book);

  // -------------- totop --------------
  $(document).scroll(function () {
    if ($(this).scrollTop() > 0) {
      $('#totop').stop().animate({
        bottom: '50px'
      }, 500)
    } else {
      $('#totop').stop().animate({
        bottom: '-80px'
      }, 500)
    }
  })

  $('#totop').on('click', function () {
    $('html,body').stop().animate({
      scrollTop: '0'
    }, 500)
  })

  $('.js-scrollTo').on('click', function (e) {
    e.preventDefault()
    let target = $(this).attr('href')
    $('html,body').stop().animate({
      scrollTop: $(target).offset().top
    }, 500)
  });


});





function PrintAuthor(author) {
  let target = document.getElementById('l-section--03__author');
  let allProject = [];
  for (let i = 0; i < author.length; i++) {
    if (author[i].sex === 'GL') {
      let project = `
        <li>
          <a href="${author[i].picUrl}" class="l-section--03__author__pic wow flipInY" target="_blank">
            <img src="img/section-03/section-03-author-${ author[i].num}.png" alt="">
            <span>GL</span>
          </a>
          <p>${author[i].name}</p>
          <a href="${ author[i].linkUrl}" class="l-section--03__author__link" target="_blank">${ author[i].link}</a>
        </li>
      `
      allProject += project;
    } else if (author[i].sex === 'BL') {
      let project = `
        <li>
          <a href="${author[i].picUrl}" class="l-section--03__author__pic wow flipInY" target="_blank">
            <img src="img/section-03/section-03-author-${author[i].num}.png" alt="">
            <span class="bl">BL</span>
          </a>
          <p>${author[i].name}</p>
          <a href="${author[i].linkUrl}" class="l-section--03__author__link" target="_blank">${author[i].link}</a>
        </li>
      `
      allProject += project;
    }
  }
  target.innerHTML = allProject;
}

function Printbook(book) {
  let target = document.getElementById('l-section--04__bookCards');
  let allProject = [];
  for (let i = 0; i < book.length; i++) {
    if (book[i].sex === 'GL') {
      let project = `
        <div class="col-6 col-md-3">
          <div class="l-section--04__bookCard">
            <a href="${book[i].picUrl}" class="l-section--04__bookCard__book wow flipInY" target="_blank">
              <img src="img/section-04/section-04-book-${book[i].num}.png" alt="">
              <span>${book[i].sex}</span>
            </a>
            <h5>${book[i].bookname}</h5>
            <h6>${book[i].name}</h6>
            <p>${book[i].text}</p>
          </div>
        </div>
      `
      allProject += project;
    } else if (book[i].sex === 'BL') {
      let project = `
      <div class="col-6 col-md-3">
        <div class="l-section--04__bookCard">
          <a href="${book[i].picUrl}" class="l-section--04__bookCard__book wow flipInY" target="_blank">
            <img src="img/section-04/section-04-book-${book[i].num}.png" alt="">
          <span class="bl">${book[i].sex}</span>
          </a>
          <h5>${book[i].bookname}</h5>
          <h6>${book[i].name}</h6>
          <p>${book[i].text}</p>
        </div>
      </div>
      `
      allProject += project;
    }
  }
  target.innerHTML = allProject;
}